import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setSubCategoryList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";

AxiosCurlirize(axios, () => {});
export const useSubCategoryListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (
      pageSize?: number,
      pageNumber?: number,
      query: string = "",
      subcategory_tagging?: string,
      emr_search?: string,
    ) => {
      dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: true }));
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const params = new URLSearchParams();
        if (query.trim() !== "") {
          params.append("search_keyword", query.trim());
        }
        if (pageSize && pageNumber) {
          params.append("page", pageSize.toString());
          params.append("page_size", pageNumber.toString());
        }
        if (subcategory_tagging) {
          params.append("subcategory_tagging", subcategory_tagging);
        }
        if (emr_search) {
          params.append("emr_search", emr_search);
        }
        const url = `${INVENTORY_MODULE?.SUB_CATEGORY_LIST?.baseURL}?${params.toString()}`;
        const res = await axios.get(url, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: false }));
        if (res.data.status === true) {
          dispatch(setSubCategoryList(res.data.data));
        } else {
          dispatch(setSubCategoryList({ data: [], item_count: 0 }));
        }
      } catch (e: any) {
        captureError(e);
        sendCurl(e.config["curlCommand"]);
        dispatch(setLoading({ key: "isInventoryProductListLoadingInProgess", status: false }));
        dispatch(setSubCategoryList({ data: [], item_count: 0 }));
      }
    },
    [dispatch],
  );

  return { execute };
};
